module.exports = __webpack_public_path__ + "static/media/report3.44491629.pdf";